import React from 'react';
import { Link } from 'react-router-dom';

const Datenschutz: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="legal-content">
        <h1>Datenschutzerklärung</h1>
        
        <h2>1. Datenschutz auf einen Blick</h2>
        
        <h3>Allgemeine Hinweise</h3>
        <p>
          Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren 
          personenbezogenen Daten passiert, wenn Sie diese Website nutzen und sich registrieren.
        </p>

        <h2>2. Datenerfassung auf dieser Website</h2>
        
        <h3>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</h3>
        <p>
          Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. 
          Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
        </p>

        <h3>Wie erfassen wir Ihre Daten?</h3>
        <p>
          Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann 
          es sich z.B. um Daten handeln, die Sie in ein Registrierungsformular eingeben (Benutzername, 
          optionale E-Mail-Adresse).
        </p>
        <p>
          Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst. 
          Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit 
          des Seitenaufrufs).
        </p>

        <h2>3. Nutzung von Drittanbieterdiensten</h2>
        
        <h3>Cloudflare CDN</h3>
        <p>
          Mit der Registrierung auf dieser Website stimmen Sie der Nutzung von <strong>Cloudflare</strong> als 
          Content Delivery Network (CDN) zu. Cloudflare wird eingesetzt, um die Geschwindigkeit und 
          Sicherheit unserer Website zu verbessern. Dabei können personenbezogene Daten wie Ihre 
          IP-Adresse von Cloudflare verarbeitet werden.
        </p>
        <p>
          Weitere Informationen finden Sie in der Datenschutzerklärung von Cloudflare: 
          <a href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noopener noreferrer">
            https://www.cloudflare.com/privacypolicy/
          </a>
        </p>

        <h3>Supabase (Datenbank)</h3>
        <p>
          Mit der Registrierung stimmen Sie der Nutzung von <strong>Supabase</strong> als Datenbank-Dienst zu. 
          Supabase speichert Ihre Registrierungsdaten (Benutzername, optionale E-Mail), Ihre 
          QR-Code-Scans, Ihre Antworten und Gruppendaten.
        </p>
        <p>
          Supabase speichert Datenbank auf Servern innerhalb Deutschlands.
          Weitere Informationen: 
          <a href="https://supabase.com/privacy" target="_blank" rel="noopener noreferrer">
            https://supabase.com/privacy
          </a>
        </p>

        <h3>GitHub (CI/CD und Hosting)</h3>
        <p>
          Mit der Nutzung stimmen Sie zu, dass <strong>GitHub Pages</strong> für das Hosting der Website 
          und <strong>GitHub Actions</strong> für das kontinuierliche Deployment (CI/CD) verwendet werden. 
          Dabei können technische Daten wie Ihre IP-Adresse und Browserinformationen von GitHub 
          verarbeitet werden.
        </p>
        <p>
          Weitere Informationen: 
          <a href="https://docs.github.com/en/site-policy/privacy-policies/github-privacy-statement" target="_blank" rel="noopener noreferrer">
            GitHub Privacy Statement
          </a>
        </p>

        <h2>4. Ihre Rechte</h2>
        <p>
          Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung oder Einschränkung 
          der Verarbeitung Ihrer gespeicherten Daten, ein Widerspruchsrecht gegen die Verarbeitung 
          sowie ein Recht auf Datenübertragbarkeit.
        </p>
        <p>
          Wenden Sie sich hierfür an: fachgruppe@inf.tu-braunschweig.de
        </p>

        <h2>5. Speicherdauer</h2>
        <p>
          Ihre Daten werden gespeichert, solange Sie ein aktives Benutzerkonto haben. Nach dem 
          Löschen Ihres Accounts werden Ihre personenbezogenen Daten gelöscht, soweit keine 
          gesetzlichen Aufbewahrungsfristen bestehen.
        </p>

        <h2>6. Cookies und Offline-Funktionalität</h2>
        <p>
          Diese Website nutzt IndexedDB (eine browserbasierte Datenbank), um Daten lokal auf 
          Ihrem Gerät zu speichern, damit die App auch offline funktioniert. Diese Daten bleiben 
          auf Ihrem Gerät und werden nicht automatisch an Dritte übertragen.
        </p>

        <h2>7. Änderungen dieser Datenschutzerklärung</h2>
        <p>
          Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den 
          aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen 
          umzusetzen.
        </p>

        <p><em>Stand: Oktober 2025</em></p>

        <div className="back-link">
          <Link to="/">← Zurück zur Startseite</Link>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;
